/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect } from 'react';
import { Ecommerce, Taxonomy } from './contracts';
import { trackPage } from './trackPage';
import { trackSegmentAndGAEvent } from './trackSegmentAndGAEvent';

/**
 * @deprecated Replaced by usePageSegmentTracking
 * A tracking hook for pageview event. The 'page' parameter is virtual url path for tracking only, e.g. in '/valuation/15116812/' page only sends '/valuation/' to datalayer.
 * @param {string} page - the page url for tracking
 * @param {object} extraTaxonomy - custom taxonomy object for pageview event
 * @param {object} extraEcommerce - custom ecommerce object for pageview event
 */
export const usePageTracking = (
    page?: string,
    extraTaxonomy: Record<string, unknown> = {},
    extraEcommerce: Record<string, unknown> | null = null
) => {
    useEffect(() => {
        const controller = new AbortController();
        if (page) {
            trackPage(page, extraTaxonomy, extraEcommerce, controller.signal);
        }
        return () => {
            controller.abort();
        };
    }, []);
};

/**
 * A tracking hook for pageview segment event. The 'page' parameter is virtual url path for tracking only, e.g. in '/valuation/15116812/' page only sends '/valuation/' to datalayer.
 * @param {string} page - the page url for tracking
 * @param {object} extraTaxonomy - custom taxonomy object for pageview event
 * @param {object} extraEcommerce - custom ecommerce object for pageview event
 */
export const usePageSegmentTracking = (
    page: string,
    extraTaxonomy?: Taxonomy,
    extraEcommerce?: Ecommerce
) => {
    useEffect(() => {
        trackSegmentAndGAEvent(
            'Viewed Page',
            {},
            page,
            extraTaxonomy,
            extraEcommerce
        );
    }, [page, extraTaxonomy, extraEcommerce]);
};
